<div class="range-pin" *ngIf="pin" role="presentation">{{val}}</div><div class="range-knob" role="presentation"></div>